// extracted by mini-css-extract-plugin
module.exports = {"headline":"Header_headline__16Q3N"};